import axios from 'axios'
import { store } from '@/store/index.js'

const getBaseUrl = () => {
  if(localStorage.getItem('selectedSASEnvDesc') === 'SNAPROD' || localStorage.getItem('selectedSASEnvDesc') === null)
  return process.env.VUE_APP_SAS_VIYA4_PROD_DOMAIN 
  else return process.env.VUE_APP_SAS_VIYA4_TEST_DOMAIN

}

const getEnvGuid = () => {
  if(localStorage.getItem('selectedSASEnvDesc') === 'SNAPROD' || localStorage.getItem('selectedSASEnvDesc') === null)
  return process.env.VUE_APP_SAS_VIYA4_PROD_COMPUTE_CONTEXT 
  else return process.env.VUE_APP_SAS_VIYA4_TEST_COMPUTE_CONTEXT
}

const baseHttpClient = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  },
  transformRequest: [function (data, headers) {
    headers.Authorization = 'Bearer ' + store.state.oidc.access_token
    return data
  }],
  withCredentials: true
})


const httpClient = axios.create({
  baseURL: getBaseUrl() + '/SASJobExecution/?_program=/RnDAdvancedAnalyticPlatform' + process.env.VUE_APP_API_ENV + '/Programs/GUIAPI',
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
})

const httpPostClient = axios.create({
  baseURL: getBaseUrl() + '/SASJobExecution/?_program=/RnDAdvancedAnalyticPlatform' + process.env.VUE_APP_API_ENV + '/Programs/GUIAPI',
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  withCredentials: true
})

// POST methods
const setComputeSession = (body) => baseHttpClient.post('/compute/contexts/' + getEnvGuid() + '/sessions', body)

const runSASCode = (sessionId, data) => baseHttpClient.post('/compute/sessions/' + sessionId + '/jobs', data)

const submitFile = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return baseHttpClient.post('/SASJobExecution/?_program=/RndAdvancedAnalyticPlatformProd/Programs/GUIAPI/UpLoadFile',
    formData,
    {
      headers: {
        Authorization: 'Bearer ' + store.state.oidc.access_token,
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}


/// Viya 4 Model: microanalyticScore/modules/ensemble_231023_1348b14ae64f44b3b7e8ec046a5c0b7f/steps/score
const getQueryPrediction = (data) => baseHttpClient.post(getBaseUrl() + '/microanalyticScore/modules/ensemble_231023_1348b14ae64f44b3b7e8ec046a5c0b7f/steps/score',
  data,
  {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  }
)

// GET methods
const pollSASJob = async (sessionId, jobId) => baseHttpClient.get('/compute/sessions/' + sessionId + '/jobs/' + jobId + '/state')

const getJobStatus = (jobId) => baseHttpClient.get('/jobExecution/jobs/' + jobId + '/state')

const getJobResult = (jobId) => baseHttpClient.get('/SASJobExecution/?_jobexec=/jobExecution/jobs/' + jobId)

const getResult = (sessionId, refId) => baseHttpClient.get(getBaseUrl() + '/compute/sessions/' + sessionId + '/filerefs/' + refId + '/content', {
  headers: {
    Accept: 'text/plain'
  }
})

const validateComputeSession = (sessionId) => baseHttpClient.get('/compute/sessions/' + sessionId + '/state')

const checkAuthentication = () => baseHttpClient.get('/SASJobExecution/keepalive')

const getDownloadData = (link) => axios.get(link, {
  responseType: 'blob',
  headers: {
    Authorization: 'Bearer ' + store.state.oidc.access_token,
    Accept: 'application/octet-stream'
  },
  onDownloadProgress: (progressEvent) => {
    var dataDownloaded = (progressEvent.loaded / 1000) //In KB
    store.commit('inspectExportDataSize', dataDownloaded)
  }
})

const retrieveJobLog = (sessionId) => baseHttpClient.get('/compute/sessions/' + sessionId + '/log')

const putSASDriveCurrentSharedWithMeFolder = (userId) => baseHttpClient.put('/preferences/preferences/' + 'PMAUTJ' + '/sas.drive.current.folder',
  JSON.stringify({
    application: 'sas.drive',
    id: 'sas.drive.current.folder',
    value: '/driveItems/share:singleton:sasDrive'
  })
)

const getCsrf = () => baseHttpClient.get('/SASJobExecution/csrf')

const computeSessions = () => baseHttpClient.get('/compute/sessions', {
  headers: {
    Authorization: 'Bearer ' + store.state.oidc.access_token,
    Accept: 'application/vnd.sas.collection+json',
    'Accept-Item': 'application/vnd.sas.compute.session+json'
  }
})


export {
  httpClient,
  httpPostClient,
  getQueryPrediction,
  submitFile,
  getCsrf,
  runSASCode,
  validateComputeSession,
  retrieveJobLog,
  putSASDriveCurrentSharedWithMeFolder,
  pollSASJob,
  computeSessions,
  getResult,
  setComputeSession,
  checkAuthentication,
  getJobStatus,
  getJobResult,
  getDownloadData
}
